export default {
  apiKey: "AIzaSyAfPuj7wfHfKyTrKd52SxIw-XPOCPB1qvY",
  authDomain: "ulsemo-dev.firebaseapp.com",
  databaseURL: "https://ulsemo-dev.firebaseio.com",
  projectId: "ulsemo-dev",
  storageBucket: "ulsemo-dev.appspot.com",
  messagingSenderId: "474207412838",
  appId: "1:474207412838:web:3530c1de148ef6e085c3a7"
}
